module.exports = __webpack_public_path__ + "img/GAZDEBORDEAUX.f1342db6.png";